<template>
    <el-dialog
      v-dialogDrag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="textMap[dialogStatus]"
      :visible.sync="dialogFormVisible"
      width="30%"
      @closed="clearForm()"
      top="2vh">
        <el-form :model="listForm" ref="listForm" :rules="validateRule" label-width="120px" size="small">
          <el-form-item v-if="this.dialogStatus=='update'" label="代码编号" prop="codeItemId">
            <el-input disabled v-model="listForm.codeItemId" />
          </el-form-item>
          <el-form-item v-if="this.dialogStatus=='add'" label="代码编号" prop="codeItemId">
            <el-input v-model="listForm.codeItemId" />
          </el-form-item>
          <el-form-item label="代码项中文名称" prop="codeItemName">
            <el-input v-model="listForm.codeItemName" />
          </el-form-item>
          <el-form-item label="拼音"  prop="codeItemSpell">
            <el-input v-model="listForm.codeItemSpell" />
          </el-form-item>
          <el-form-item label="英文名称" prop="codeItemEnName">
            <el-input v-model="listForm.codeItemEnName" />
          </el-form-item>
          <el-form-item v-if="this.dialogStatus=='update'" label="父节点" prop="superId">
            <el-input disabled v-model="listForm.superId" />
          </el-form-item>
          <el-form-item label="值" prop="codeItemCompareValue">
            <el-input v-model="listForm.codeItemCompareValue" />
          </el-form-item>
          <el-form-item label="状态" prop="codeItemStatus">
            <el-select :disabled="tableItem" v-model="listForm.codeItemStatus" placeholder="请选择">
              <el-option key="0" value="0" label="禁用"></el-option>
              <el-option key="1" value="1" label="启用"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="air-modal-footer flex jend acenter">
          <el-button @click="cancel()">取 消</el-button>
          <el-button type="primary" :disabled="btnUnable" @click="handlerListForm()">保 存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {saveCodeItem,updatecode} from "@/api/sys/code"
import { type } from 'os'
export default {
    name: 'SysCodeItemDialog',
    props:{
        dialogStatus:{
            type: String,
            default: ""
        },
        dialogFormVisible: {
            type: Boolean
        },
        listForm:{
            type:Object,
            default() {
              return {}
            }
        },
        rowCodeSetId:{
            type: String,
            default: ''
        }
    },
    data() {
        return {
            btnUnable: false,
            textMap: {
                add: "新增参数",
                update: "编辑参数"
            },
            validateRule:{
                codeItemName: [
                    { required: true, message: "代码项中文名称不能为空！", trigger: "blur"}
                ],
                codeItemEnName: [
                    { required: true, message: "代码项英文名不能为空！", trigger: "blur"}
                ]
            }
        }
    },
    methods: {
        handlerListForm() {
            if (this.dialogStatus == "add") {
            this.addForm();
            } else if (this.dialogStatus == "update") {
            this.updateForm();
            }
        },
        addForm(){
            this.$refs.listForm.validate((valid) => {
                this.btnUnable=true
                if(valid){
                    this.$set(this.listForm, 'codeSetId', this.rowCodeSetId)
                    saveCodeItem(this.listForm).then((res)=>{
                        if (res.data.code == 0){
                            this.dialogFormVisible = false;
                            this.btnUnable=false
                            this.$emit('data-refresh');
                            this.$message.success('操作完成');
                        } else {
                            this.btnUnable=false
                            this.$message.error('操作失败');
                        }
                        if(res.status==500){
                            this.btnUnable=false
                        }
                    })
                }
            })
        },
        updateForm() {
            this.btnUnable=true
            this.$refs.listForm.validate((valid) => {
                if (valid){
                  updatecode(this.listForm).then(res => {
                        let rs=res.data
                        if (rs.code == 0){
                            this.btnUnable=false
                            this.$emit('data-refresh');

                          this.$message.success('操作完成');
                            // this.dialogFormVisible = false;
                            this.$emit('update:dialogFormVisible',false)
                        } else {
                            this.btnUnable=false
                            this.$message.error('操作失败');
                        }
                    })
                }else{
                    this.btnUnable=false
                }
            })
        },
        // 关闭后清空dialog
        clearForm(){
        this.$refs.listForm.resetFields()
        this.$refs.listForm.clearValidate()
        this.dialogFormVisible = false
        this.btnUnable=false
        this.$emit('update:dialogFormVisible',false)
        },
        cancel(){
            this.dialogFormVisible = false
            this.$emit('update:dialogFormVisible',false)
        }
    }
}
</script>
